module.exports = __webpack_public_path__ + "img/ghan-thin-01.979c67fc.jpg";